/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LanguageQuickList from './LanguageQuickList';

import api from 'api';

import userSelector from 'redux/reduxStore/user';
import listLocaleSelector from 'redux/reduxStore/lists/listLocale';
import localeSelector from 'redux/reduxStore/locale';
import sessionSelector from 'redux/reduxStore/session';

import uiStateActions from 'redux/actions/uiState';
import localeActions from 'redux/actions/locale';
import userActions from 'redux/actions/user';

function mapStateToProps(state) {
  const localeList = listLocaleSelector.getCollection(state);
  const defaultLanguageCode = localeSelector.getDefaultClientLocale(state);
  const defaultLocale = localeList.filter(l => l.language_code === defaultLanguageCode)[0];
  const preferredLanguageId = userSelector.getLocaleId(state);
  const selectedLocale = preferredLanguageId ? listLocaleSelector.getLocale(state, preferredLanguageId) : defaultLocale;
  return {
    value: userSelector.getLocaleId(state) || defaultLocale.id,
    selectedLocale,
    localeList,
    isLoggedIn: sessionSelector.isLoggedIn(state),
    user: userSelector.getLoggedInUser(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadInitialData: () => {
      // dispatch(listActions.locale.request());
    },
    showApiError: (apiError) => {
      dispatch(uiStateActions.showApiError(apiError));
    },
    updateUser: (userData) => {
      return dispatch(userActions.receive(userData));
    },
    updateLocale: (localeData) => {
      return dispatch(localeActions.setCurrentLocale(localeData));
    }
  };
}

const PreferredLanguageQuickList = (props) => (
  <LanguageQuickList
    {...props}
    value={props.value}
    onChange={(localeData) => {
      if (props.isLoggedIn) {
        const userData = _.assign({}, props.user, {
          locale_id: localeData.id,
        });

        api.userApi.update(userData)
          .then(() => props.updateUser(userData))
          .then(() => props.updateLocale(localeData))
          .catch(props.showApiError);
      } else {
        props.updateLocale(localeData);
      }
    }}
  />
);
PreferredLanguageQuickList.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PreferredLanguageQuickList);
